import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * Changes the current IDs when the current list changes
 */
export const onChangeInCurrentList = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) => {
    const { onChangeInCurrentList: onChange } = plugin.config
    if (!onChange) {
      return
    }

    return plugin.collection.plugins.currentListPlugin.feature.selectors.entities.asObservable.pipe(
      // Prevents emissions until the entity collection is ready
      rxjsUtils.delayUntil(plugin.collection.ready$, { maxDelayed: 1 }),
      // Gets current IDs
      rxjsUtils.latestFrom(entities => ({
        currentEntityIds: plugin.storage.selectors.idLookup.asObservable,
        entities: rxjs.of(entities),
      })),
      // Creates the update action
      rxjs.map(({ currentEntityIds, entities }) => {
        const results = onChange(entities, currentEntityIds)
        // The action does not accept properties that are undefined, so this is
        // a copy that has no undefined properties
        const nonPartialResults: Record<ecModels.Target, ecModels.EntityId> = {}
        for (const k in results) {
          if (results[k]) {
            nonPartialResults[k] = results[k]
          }
        }
        return plugin.storage.actions.setIdLookup
          .from('onChangeInCurrentList (effect)')
          .create(nonPartialResults)
      }),
    )
  },
)
